import React, { useState, useEffect } from 'react';
import DirectChat from '../DirectChat/DirectChat';

const SPLASH_DURATION = 2200;

export default function AstroDeepak({ darkMode, toggleDarkMode }) {
  const [showSplash, setShowSplash] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFadeOut(true), SPLASH_DURATION - 400);
    const hideTimer = setTimeout(() => setShowSplash(false), SPLASH_DURATION);
    return () => { clearTimeout(fadeTimer); clearTimeout(hideTimer); };
  }, []);

  if (showSplash) {
    return (
      <div style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'linear-gradient(135deg, #3d7a35 0%, #61A456 50%, #7ec275 100%)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        transition: 'opacity 0.4s ease',
        opacity: fadeOut ? 0 : 1,
      }}>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{
            fontFamily: "'Georgia', 'Times New Roman', serif",
            fontSize: 48, fontWeight: 700, color: '#fff',
            letterSpacing: '-0.02em', lineHeight: 1,
            margin: 0,
          }}>
            Astro Deepak
          </h1>
          <p style={{
            fontFamily: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
            fontSize: 16, fontWeight: 500, color: 'rgba(255,255,255,0.7)',
            letterSpacing: '0.02em',
            marginTop: 10,
          }}>
            Your AI Astrologer
          </p>
        </div>
      </div>
    );
  }

  return <DirectChat slug="astrodeepak" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />;
}
